import { useTranslation } from 'react-i18next';
import React from 'react';
import BoldVerticalBarChart, {
	BoldVerticalBarChartProps,
} from '@components/report/chart/bold-vertical-bar-chart/BoldVerticalBarChart';
import VerticalBarAverageChart, {
	VerticalBarAverageChartProps,
} from '@components/report/chart/vertical-bar-average-chart/VerticalBarAverageChart';
import ReportCard from '@components/report/report-card/ReportCard';
import { threeDivisionGridClass } from '@components/report/style.css';

export interface EngagementYtProps {
	averageViews?: VerticalBarAverageChartProps;
	averageLikes?: VerticalBarAverageChartProps;
	averageComments?: VerticalBarAverageChartProps;
	engagementRate?: BoldVerticalBarChartProps;
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const EngagementYt = ({
	averageViews,
	averageLikes,
	averageComments,
	engagementRate,
	isLoading,
	isError,
	lackOfPermission,
}: EngagementYtProps) => {
	const { t } = useTranslation('infReportYoutube');
	const status = { isLoading, isError, lackOfPermission };
	return (
		<div className={threeDivisionGridClass}>
			<ReportCard
				label={t('features.report.section-content.yt.engagement-yt.average-views.label')}
				tooltip={t(
					'features.report.section-content.yt.engagement-yt.average-views.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc={t(
						'features.report.section-content.yt.engagement-yt.average-views.vertical-bar-average-chart.sub-description',
					)}
					valueUnit={t(
						'features.report.section-content.yt.engagement-yt.average-views.vertical-bar-average-chart.value-unit',
					)}
					label={t(
						'features.report.section-content.yt.engagement-yt.average-views.vertical-bar-average-chart.label',
					)}
					desc={true}
					{...averageViews}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label={t('features.report.section-content.yt.engagement-yt.average-likes.label')}
				tooltip={t(
					'features.report.section-content.yt.engagement-yt.average-likes.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc={t(
						'features.report.section-content.yt.engagement-yt.average-likes.vertical-bar-average-chart.sub-description',
					)}
					valueUnit={t(
						'features.report.section-content.yt.engagement-yt.average-likes.vertical-bar-average-chart.value-unit',
					)}
					label={t(
						'features.report.section-content.yt.engagement-yt.average-likes.vertical-bar-average-chart.label',
					)}
					desc={true}
					{...averageLikes}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label={t(
					'features.report.section-content.yt.engagement-yt.average-comments.label',
				)}
				tooltip={t(
					'features.report.section-content.yt.engagement-yt.average-comments.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc={t(
						'features.report.section-content.yt.engagement-yt.average-comments.vertical-bar-average-chart.sub-description',
					)}
					valueUnit={t(
						'features.report.section-content.yt.engagement-yt.average-comments.vertical-bar-average-chart.value-unit',
					)}
					label={t(
						'features.report.section-content.yt.engagement-yt.average-comments.vertical-bar-average-chart.label',
					)}
					desc={true}
					{...averageComments}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label={t(
					'features.report.section-content.yt.engagement-yt.engagement-rate.label',
				)}
				tooltip={t(
					'features.report.section-content.yt.engagement-yt.engagement-rate.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<BoldVerticalBarChart
					desc={true}
					data={[{ isMain: true }, {}]}
					{...status}
					{...engagementRate}
				/>
			</ReportCard>
		</div>
	);
};

export default EngagementYt;
